export default defineNuxtPlugin((nuxtApp) => {
  const runtimeConfig = useRuntimeConfig();
  nuxtApp.hook('app:mounted', () => {
    const script = document.createElement('script');
    script.src = `https://api.goaffpro.com/loader.js?shop=${runtimeConfig.public.GOAFFPRO_SHOP_ID}`;
    script.type = 'text/javascript';
    document.head.appendChild(script);
  });
});
